import axios from "axios";
import { OpenAPI } from "../../../common/api/openapi";
import type { WithRegion } from "../../../common/api/types";
import type { AddKceRoleRequestParams } from "./types/iam";
import { AddKceRoleResponseSchema } from "./schema/iam";

const req = new OpenAPI("/api/cluster");

export function addKceRole(params: WithRegion<AddKceRoleRequestParams>) {
  return axios(
    req.post("AddKceRole", params.Region, {
      responseSchema: {
        response: AddKceRoleResponseSchema,
      },
      data: params,
    }),
  );
}
